import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { StyledWindowMask } from "./window-mask.scss";
import DefaultProps from "./default-props";
const WindowMask = (props)=>{
    const { children } = props;
    return /*#__PURE__*/ _jsxs(StyledWindowMask, {
        className: "window-mask",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "window-header",
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "circle-wrapper",
                    children: [
                        /*#__PURE__*/ _jsx("span", {
                            className: "circle"
                        }),
                        /*#__PURE__*/ _jsx("span", {
                            className: "circle"
                        }),
                        /*#__PURE__*/ _jsx("span", {
                            className: "circle"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "content-wrapper",
                children: children
            })
        ]
    });
};
export default WindowMask;
WindowMask.defaultProps = DefaultProps;
